import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { SanitizedHtml } from "../../../../../../utils";
import { useMessageBoxActions } from "../hooks/useMessageBoxActions";

const MessageBox = ({ message, cardDescription, setCardTitle, cardId }) => {
  const [isParsable, setIsParsable] = useState(false);
  const [parsedData, setParsedData] = useState(null);
  const [content, setContent] = useState(message.content);

  useEffect(() => {
    try {
      let parsedContent = JSON.parse(message.content);

      if (parsedContent.suggestedTitle && parsedContent.suggestedDescription) {
        setIsParsable(true);
        setParsedData(parsedContent);

        let formattedContent = message.content.slice(1, -1);

        if (formattedContent.includes("suggestedTitle")) {
          formattedContent = formattedContent.replace(
            /"suggestedTitle":/g,
            "<h3>Title: </h3>"
          );
        }
        if (formattedContent.includes("suggestedDescription")) {
          formattedContent = formattedContent.replace(
            /"suggestedDescription":/g,
            "<br><h4>Description: </h4>"
          );
          formattedContent = formattedContent.replace(/",/g, '"');
          formattedContent = formattedContent.replace(/"/g, "");
        }

        setContent(formattedContent);
      } else {
        setIsParsable(false);
      }
    } catch (error) {
      setIsParsable(false);
      setContent(message.content);
    }
  }, [message.content]);

  const { applySuggestedChanges } = useMessageBoxActions({
    cardId,
    cardDescription,
    setCardTitle,
  });

  const handleArrowClick = () => {
    applySuggestedChanges(parsedData);
  };

  return (
    <Box
      className={message.role === "user" ? "chat-msg-cont" : "chat-ai-msg-cont"}
    >
      <Typography
        variant="body1"
        className={message.role === "user" ? "chat-user-msg" : "chat-ai-msg"}
        component="div"
      >
        <SanitizedHtml as="div" html={content.replace(/\\n/g, "<br />")} />
      </Typography>
      {message.role === "assistant" && isParsable && (
        <Box
          sx={{
            cursor: "pointer",
            zIndex: 1,
            fontSize: "50px",
            transition: "transform 0.2s",
            "&:hover": { transform: "translateX(-15px)" },
          }}
          onClick={handleArrowClick}
        >
          ←
        </Box>
      )}
    </Box>
  );
};

export default MessageBox;
